// extracted by mini-css-extract-plugin
module.exports = {"baseMap":"Map_baseMap__2Y9uc"};